import { ExerciseFeedback, SessionFeedback } from '@/types/ai-training'

export type CombinedFeedback = {
  session_feedback: SessionFeedback
  exercise_feedback: ExerciseFeedback[]
}

const EXERCISE_PREFIX = 'training-feedback-'
const SESSION_PREFIX = 'session-feedback-'
const HISTORY_KEY = 'trainiq-feedback-history'

export function getExerciseFeedback(trainingId: string): ExerciseFeedback[] {
  try {
    const raw = localStorage.getItem(EXERCISE_PREFIX + trainingId)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? (parsed as ExerciseFeedback[]) : []
  } catch {
    return []
  }
}

export function saveExerciseFeedback(trainingId: string, feedbacks: ExerciseFeedback[]): void {
  try {
    localStorage.setItem(EXERCISE_PREFIX + trainingId, JSON.stringify(feedbacks))
  } catch (e) {
    console.error('Failed to save exercise feedback', e)
  }
}

export function appendExerciseFeedback(trainingId: string, feedback: ExerciseFeedback): void {
  const current = getExerciseFeedback(trainingId)
  const idx = current.findIndex(f => f.exercise_id === feedback.exercise_id)
  if (idx >= 0) current[idx] = feedback
  else current.push(feedback)
  saveExerciseFeedback(trainingId, current)
}

export function saveSessionFeedback(session: SessionFeedback): void {
  try {
    localStorage.setItem(SESSION_PREFIX + session.session_id, JSON.stringify(session))
  } catch (e) {
    console.error('Failed to save session feedback', e)
  }
}

export function appendFeedbackHistory(item: CombinedFeedback): void {
  try {
    const raw = localStorage.getItem(HISTORY_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    const list: CombinedFeedback[] = Array.isArray(parsed) ? parsed : []
    list.unshift(item)
    localStorage.setItem(HISTORY_KEY, JSON.stringify(list))
  } catch (e) {
    console.error('Failed to append feedback history', e)
  }
}

export function getFeedbackHistory(): CombinedFeedback[] {
  try {
    const raw = localStorage.getItem(HISTORY_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? (parsed as CombinedFeedback[]) : []
  } catch {
    return []
  }
}

export function submitCombinedFeedback(session: SessionFeedback, exercises: ExerciseFeedback[]): void {
  saveSessionFeedback(session)
  appendFeedbackHistory({ session_feedback: session, exercise_feedback: exercises })
}
